import { createSelector } from 'reselect';

const getRouter = (state) => state.router;

const getLocation = (state) => getRouter(state).location;

const RouterSelectors = {
  makeRouter: createSelector([getRouter], (router) => router),
  makeLocation: createSelector([getLocation], (location) => location),
  makeSearch: createSelector([getLocation], (location) => location.search),
  makePathname: createSelector([getLocation], (location) => location.pathname),
};

export default RouterSelectors;
